// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import ProductPriceAndActions, {
    ProductPriceAndActionsStyle,
} from "@guestsupply/App/Components/Product/ProductPriceAndActions";
import { hideElementOnPrint, xScreen } from "@guestsupply/XDL/Utilities";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasProductContext, withProductContext } from "@insite/client-framework/Components/ProductContext";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import React, { FC } from "react";
import { css } from "styled-components";

type Props = WidgetProps & HasProductContext;

export interface ProductDetailsActionsStyles {
    productPriceAndActionsStyle?: ProductPriceAndActionsStyle;
}

export const productDetailsActionsStyles: ProductDetailsActionsStyles = {
    productPriceAndActionsStyle: {
        productActionsStyles: {
            addToCartContainer: {
                css: css`
                    ${hideElementOnPrint}
                `,
            },
        },
        productGridContainer: {
            container: {
                css: css`
                    & > .bottom-section {
                        flex-direction: row;
                        flex-wrap: wrap;
                        @media print {
                            gap: 0;
                        }
                    }
                `,
            },
            addToCartActions: {
                css: css`
                    ${xScreen("lte", "sm")} {
                        width: 100%;
                    }
                `,
            },
            price: {
                css: css`
                    flex: 0 0 100%;
                    margin-bottom: 4px;
                `,
            },
            availability: {
                css: css`
                    order: 3;
                `,
            },
            addToList: {
                css: css`
                    order: 4;
                    ${xScreen("lte", "md")} {
                        margin-left: auto;
                    }
                `,
            },
            priceAvailabilityContainer: {
                css: css`
                    width: 100%;
                `,
            },
        },
        productPriceStyles: {
            price: {
                priceText: {
                    css: css`
                        font-size: 28px;
                        @media print {
                            font-size: 18px;
                            font-weight: bold;
                        }
                    `,
                },
                unitOfMeasure: {
                    unitOfMeasureText: {
                        css: css`
                            @media print {
                                font-size: 18px;
                                font-weight: bold;
                            }
                        `,
                    },
                },
            },
        },
    },
};

const styles = productDetailsActionsStyles;

const ProductDetailsActions: FC<Props> = ({ productContext }) => {
    return (
        <ProductPriceAndActions
            showAddToList={true}
            showAvailability={false}
            showPrice={true}
            showAddToCartActions={true}
            iconOnly={true}
            showDisabled={true}
            displayAutoReorderAsButton={true}
            extendedStyles={styles.productPriceAndActionsStyle}
            isPdp={true}
        />
    );
};

const widgetModule: WidgetModule = {
    component: withProductContext(ProductDetailsActions),
    definition: {
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;
